export default __webpack_public_path__ + "static/media/lightbulb.288ca00c.svg";